import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {AbstractInputDirective} from '../AbstractInputDirective';
import {GetUsers} from '../../services/user/GetUsers';
import {UserService} from '../../services/user/user.service';
import {StringUtil} from '../../StringUtil';
import {TeamMember} from '../../model/team/TeamMember';
import {IGenericMap} from '../../model/generic-map.interface';
import {GetTeamRoles} from '../../services/team-role/GetTeamRoles';
import {TeamRoleService} from '../../services/team-role/team-role.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'digires-team-member-input',
  templateUrl: './team-member-input.component.html',
  styleUrls: ['./team-member-input.component.scss']
})
export class TeamMemberInputComponent extends AbstractInputDirective implements OnInit, OnChanges {

  @Output() onSelected = new EventEmitter<TeamMember>();
  @Input() allTeamMembers: TeamMember[];
  validMembers: TeamMemberEntry[];
  filteredMembers: TeamMemberEntry[];
  idToUser: IGenericMap<GetUsers> = {};
  idToRole: IGenericMap<GetTeamRoles> = {};

  internalFormGroup: FormGroup;

  constructor(
    private userService: UserService,
    private roleService: TeamRoleService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.userService.fetchAllUsers()
      .then(userMap => {
        this.idToUser = userMap;
        this.updateValidMembers();
      });
    this.roleService
      .fetchAllTeamRolesAsMap()
      .then(roleMap => {
        this.idToRole = roleMap;
        this.updateValidMembers();
      });

    this.internalFormGroup = new FormGroup({
      value: new FormControl(),
    });
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.updateValidMembers();
  }

  private updateValidMembers() {
    this.validMembers = this.allTeamMembers
      .filter(member => !!member && !!member.userId && !!member.roleId)
      .map(member => {
        return {
          teamMember: member,
          label: this.getLabelFor(member),
        };
      });
    this.filteredMembers = this.validMembers;

    if (this.internalFormGroup) {
      const selectedMember = this.deepFormGroup.value[this.formCtrlName];
      const selectedEntry = this.validMembers.find(entry => entry.teamMember.userId === selectedMember?.userId
        && entry.teamMember.roleId === selectedMember?.roleId);
      this.internalFormGroup.patchValue({
        value: selectedEntry,
      });
    }
  }

  onFilterMembers(event: any): void {
    const value = event.target.value;
    if (!value) {
      this.onMemberSelected(null);
      return;
    }
    const lowerCaseVal: string = value.toLowerCase();
    this.filteredMembers = this.validMembers.filter(entry => {
      return StringUtil.filteredIncludes(entry.label, lowerCaseVal);
    });

    const foundOpt = this.filteredMembers.find(entry => {
      return entry.label.toLowerCase() === lowerCaseVal;
    });
    if (foundOpt) {
      this.onMemberSelected(foundOpt);
    }
  }

  onMemberSelected(entry: TeamMemberEntry): void {
    this.filteredMembers = this.validMembers;
    this.internalFormGroup.patchValue({value: entry});
    this.patch(entry ? entry.teamMember : null);
    this.onSelected.emit(entry ? entry.teamMember : null);
  }

  reset() {
    this.internalFormGroup.patchValue({value: null});
    this.patch(null);
  }

  getLabelFor(member: TeamMember): string {
    if (!member) {
      return '';
    }
    const memberName = this.idToUser[member.userId]?.fullName || member.userId;
    const roleName = this.idToRole[member.roleId]?.name || member.roleId;
    return `${memberName} (${roleName})`;
  }

  getLabel(entry: TeamMemberEntry): string {
    return entry?.label;
  }

}
interface TeamMemberEntry {
  teamMember: TeamMember;
  label: string;
}
